import { BlockedUserCreationFormLogic } from '@exam-center/blocked-user-creation';

export default function AdminBlocklistCreatePage() {
  return <BlockedUserCreationFormLogic />;
}
